import ModuleCachingState from "./ModuleCachingState";

export default class ModuleCachingStateChangeEvent extends Event {
    static type = "ModuleCachingStateChangeEvent";
    constructor(public state: ModuleCachingState) {
        super(ModuleCachingStateChangeEvent.type);
    }
}
